<template> 
    <div class="group">
        <div class="title h_48">运费模板</div>
        <Card >
            <Button type="primary" class="addBtn" @click="addGroup">新建运费模板</Button>
            <Table  :columns="columns" :data="list">
                <template slot-scope="{row ,index }" slot="action">
                    <Button type="text"  @click="updateBtn(row,index)">编辑</Button> 
                    <Button type="text" class="delBtn" @click="del(row,index)">删除</Button>  
                </template>
            </Table>
        </Card>

        <Modal
            v-model="visible"
            title="添加运费模板"
             width="900"
            :footer-hide="true"
            >

            <Form   :label-width="100" >
                <FormItem label="模板名称：" prop="sort">
                    <Input v-model="name" placeholder="模板名称" style="width:300px" />
                </FormItem>
                <FormItem label="计费方式：" >
                      <Radio :value="true">计件数</Radio>
                </FormItem>
                <FormItem label="配送区域：">
                    <Table :columns="editColumns" :data="edit" >
                        <template slot="region">
                            <span>全国</span>
                        </template>
                        <template  slot="frist">
                            <InputNumber :max="999" :min="0" v-model="edit[0].frist" @on-blur='fristInputBlur' />
                        </template>
                        <template   slot="fristPrice">
                            <Input v-model="edit[0].fristPrice" @on-blur='fristPriceInputBlur' />
                        </template>
                        <template  slot="continued">
                            <InputNumber :max="999" :min="0" v-model="edit[0].continued"  @on-blur='continuedInputBlur' />
                        </template>
                        <template   slot="continuedPrice" >
                            <Input v-model="edit[0].continuedPrice" @on-blur='continuedPriceInputBlur'/>
                        </template>
                    </Table>
                </FormItem>
                
            </Form>
            <div class="modal-footer">
                <Button type="primary" @click="submit">保存</Button>
                <Button style="marginLeft:20px" @click="visible=false">返回</Button>
            </div>
        </Modal>
    </div>
</template> 
<script>
import { mapState } from 'vuex'
import axios from 'axios'
    export default {
        name:'goods',
        data () {
            return { 
                guid:0,         //用户guid
                freightGuid:0,  //编辑时，运费模板的guid
                token:'',
                columns: [
                    {
                        title: '运费模板名称',
                        key: 'name'
                    },
                    {
                        title: '首件（个）',
                        key: 'frist',
                        width:150
                    },
                    {
                        title: '运费（元）',
                        render:(h,params )=>{
                            return h(
                                'span',params.row.fristPrice/100
                            )
                        },
                        width:150
                    },
                    {
                        title: '续件（个）',
                        key: 'continued',
                        width:150
                    },
                    {
                        title: '续费（元）',
                        render:(h,params )=>{
                            return h(
                                'span',params.row.continuedPrice/100
                            )
                        },
                        width:150
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                    },
                    {
                        title: '操作',
                        width:170,
                        slot: 'action',
                    }
                ],  
                editColumns:[
                    {
                        title: '可配送区域',
                        slot: 'region'
                    },{
                        title: '首件（个）',
                        slot: 'frist'
                    },{
                        title: '运费（元）',
                        slot: 'fristPrice'
                    },{
                        title: '续件（个）',
                        slot: 'continued'
                    },{
                        title: '续费（元）',
                        slot: 'continuedPrice'
                    }
                ],
                name:'',//运费模板名字
                edit:[{
                    frist:1,
                    fristPrice:0,
                    continued:0,
                    continuedPrice:0
                }],
               
                visible:false,
                isEdit:true,    //判断编辑还是 添加 
                list:[] 
            }
        },
        created(){
           this.getData()
            this.guid = this.$store.state.guid
        },
        methods: {
            //获取全部分组商品
            getData(){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/freight/all/get'})
                    .then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.list = res.data.data
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            },
            //添加分组
            addGroup(){
                this.visible = true
                this.isEdit = false
                this.name = ''
                this.edit[0].frist=1
                this.edit[0].fristPrice=0
                this.edit[0].continued=0
                this.edit[0].continuedPrice=0
            },
            //编辑按钮
            updateBtn(row){
                console.log(row)
                this.isEdit = true
                this.visible = true
                this.freightGuid = row.guid
                this.name = row.name
                this.edit[0].frist=row.frist
                this.edit[0].fristPrice=row.fristPrice/100
                this.edit[0].continued=row.continued
                this.edit[0].continuedPrice=row.continuedPrice/100
               
            },
            fristPriceInputBlur(){
                this.edit[0].fristPrice =  parseFloat(this.edit[0].fristPrice).toFixed(2)
            },
            continuedPriceInputBlur(){
                this.edit[0].continuedPrice =  parseFloat(this.edit[0].continuedPrice).toFixed(2)
            },
            fristInputBlur(){
                this.edit[0].frist = Math.ceil( this.edit[0].frist) 
                
            },
            continuedInputBlur(){
                this.edit[0].continued = Math.ceil( this.edit[0].continued) 
                this.edit[0].continued==0?this.edit[0].continuedPrice=0:''
            },
            //确定
            submit(){

                if(this.name == ''){
                    this.$Message.error('请先输入运费模板名称！！！');
                }else{
                    if(this.isEdit){
                        //编辑
                        let params = this.edit[0]
                        params.fristPrice = params.fristPrice*100
                        params.continuedPrice = params.continuedPrice*100
                        params.name = this.name
                        params.guid=this.freightGuid
                        console.log(params)
                        axios({
                            url:'https://api.jiapuji.vip/gateway/admin/service/mail/freight/update?route=/layout/goods/freight/update',
                            method:'PUT',
                            data:params
                        }).then(res=>{
                            if(res.status == 200 && res.data.code==1){
                                this.$Message.success('修改成功！');
                                this.getData()
                                this.visible = false
                            }else{
                                this.$Message.error('网络异常');
                            }
                        })
                    }else{
                        //新增
                        let params = this.edit[0]
                        params.fristPrice = params.fristPrice*100
                        params.continuedPrice = params.continuedPrice*100
                        params.name = this.name
                        axios({
                            url:'https://api.jiapuji.vip/gateway/admin/service/mail/freight/add?route=/layout/goods/freight/add',
                            method:'POST',
                            data:params
                        }).then(res=>{
                            if(res.status == 200 && res.data.code==1){
                                this.$Message.success('添加成功！');
                                this.getData()
                                this.visible = false
                            }else{
                                this.$Message.error('网络异常');
                            }
                        })
                    } 

                    
                }

                 
            },
            //删除运费模板
            del(row,index){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/freight/delete?route=/layout/goods/freight/delete&guid='+row.guid,
                    method:'DELETE'
                }).then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.$Message.success('删除成功！')
                        const temList = []
                        this.list.forEach((item,i)=>{
                            if(i!=index){
                                temList.push(item)
                            }
                        })
                        this.list = temList
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            }
        },
      
        
    }
</script>  
<style scoped>
    .group{
        padding: 20px;
    }
    .title{
        color: #333;
    }
    .title::before{
        content: '\258D';
        color: #1abc9c;
        font-weight: 900;
        margin-right: 10px;
    }
    .addBtn{
        margin-bottom: 20px;
    }
    .group-image{
        width: 70px;
        height: 70px;
        margin: 20;
        margin: 10px;
    }
    .modal-header{
        color:'#2d8cf0';
        padding-bottom:5px ;
        margin-bottom: 20px;
        border-bottom: 1px solid #CCCCCC;
    }
    .modal-footer{
        text-align: right;
        background-color: white;
    }
    .tem-image{
        width: 200px;
        height: 100px;
        object-fit: contain;
    }
    .delBtn{
        color:red;
    }
</style>